<script setup>
const scrollToWaitlist = () => {
  const element = document.getElementById('waitlist')
  if (element) {
    element.scrollIntoView({ behavior: 'smooth' })
  }
}
</script>

<template>
  <section id="hero" class="relative min-h-screen flex items-center">
    <!-- Gradient Background -->
    <div class="absolute inset-0 bg-gradient-to-br from-kannister-blue-50 via-white to-kannister-blue-50 -z-10"></div>

    <div class="section-container py-20">
      <div class="max-w-4xl mx-auto text-center">
        <!-- Main Headline -->
        <h1 class="text-5xl md:text-6xl lg:text-7xl font-bold text-kannister-dark-900 leading-tight">
          Secure Development Environments <span class="text-kannister-blue-600">That Just Work</span>
        </h1>

        <!-- Subheadline -->
        <p class="mt-6 text-xl md:text-2xl text-kannister-dark-600 max-w-3xl mx-auto">
          Enterprise-grade policy and governance for dev containers. Extends the .devcontainer standard with <strong>zero config changes</strong>. Built for developers, trusted by security teams.
        </p>

        <!-- CTAs -->
        <div class="mt-10 flex flex-col sm:flex-row gap-4 justify-center items-center">
          <button
            @click="scrollToWaitlist"
            class="btn-primary text-lg px-8 py-4 w-full sm:w-auto"
          >
            Join Waitlist
          </button>
          <a
            href="https://github.com/kannister-app"
            target="_blank"
            rel="noopener noreferrer"
            class="btn-secondary text-lg px-8 py-4 w-full sm:w-auto inline-block text-center"
          >
            View on GitHub
          </a>
        </div>

        <!-- Trust Badges -->
        <div class="mt-12 flex flex-wrap justify-center items-center gap-6 text-sm text-kannister-dark-600">
          <div class="flex items-center space-x-2">
            <svg class="w-5 h-5 text-kannister-blue-600" fill="currentColor" viewBox="0 0 20 20">
              <path fill-rule="evenodd" d="M2.166 4.999A11.954 11.954 0 0010 1.944 11.954 11.954 0 0017.834 5c.11.65.166 1.32.166 2.001 0 5.225-3.34 9.67-8 11.317C5.34 16.67 2 12.225 2 7c0-.682.057-1.35.166-2.001zm11.541 3.708a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd" />
            </svg>
            <span class="font-medium">SOC2 Compliant</span>
          </div>
          <div class="flex items-center space-x-2">
            <svg class="w-5 h-5 text-kannister-blue-600" fill="currentColor" viewBox="0 0 20 20">
              <path d="M10 12a2 2 0 100-4 2 2 0 000 4z" />
              <path fill-rule="evenodd" d="M.458 10C1.732 5.943 5.522 3 10 3s8.268 2.943 9.542 7c-1.274 4.057-5.064 7-9.542 7S1.732 14.057.458 10zM14 10a4 4 0 11-8 0 4 4 0 018 0z" clip-rule="evenodd" />
            </svg>
            <span class="font-medium">Open Source</span>
          </div>
          <div class="flex items-center space-x-2">
            <svg class="w-5 h-5 text-kannister-blue-600" fill="currentColor" viewBox="0 0 20 20">
              <path fill-rule="evenodd" d="M6 6V5a3 3 0 013-3h2a3 3 0 013 3v1h2a2 2 0 012 2v3.57A22.952 22.952 0 0110 13a22.95 22.95 0 01-8-1.43V8a2 2 0 012-2h2zm2-1a1 1 0 011-1h2a1 1 0 011 1v1H8V5zm1 5a1 1 0 011-1h.01a1 1 0 110 2H10a1 1 0 01-1-1z" clip-rule="evenodd" />
              <path d="M2 13.692V16a2 2 0 002 2h12a2 2 0 002-2v-2.308A24.974 24.974 0 0110 15c-2.796 0-5.487-.46-8-1.308z" />
            </svg>
            <span class="font-medium">Enterprise Ready</span>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
